// src/pages/pengamatan/buah-alami/draftActions.js
import { useState } from 'react';

export const useDraftActions = ({
  selectedItems,
  orders,
  currentTab,
}) => {

  // Helper function untuk mendapatkan pengamatanKey unik dari selectedItems
  const getUniquePengamatanKeys = () => {
    return [...new Set(
      selectedItems.map(itemId => {
        const [pengamatanKey] = itemId.split('-');
        return pengamatanKey;
      })
    )];
  };

  // Helper function untuk mendapatkan orders yang dipilih berdasarkan id_pengamatan
  const getSelectedOrders = () => {
    const selectedOrders = orders.filter(order => 
      selectedItems.includes(order.pengamatanKey)
    );
    
    return selectedOrders;
  };

  const showDraftMenu = () => {
    if (selectedItems.length === 0) return false;
    return currentTab === 'Approved' || currentTab === 'Processed';
  };

  const showProcessedMenu = () => {
    if (selectedItems.length === 0) return false;
    return currentTab === 'Approved';
  };

  const showApprovedMenu = () => {
    if (selectedItems.length === 0) return false;
    return currentTab === 'Processed';
  };

  const showDownloadEntryMenu = () => {
    if (selectedItems.length === 0) return false;
    return currentTab === 'Processed' || currentTab === 'Closing';
  };

  const allSelectedItemsAreOnlyProcessed = () => {
    if (selectedItems.length === 0) return false;
    const selectedOrders = getSelectedOrders();
    return selectedOrders.every(order => 
      order.allPlots && order.allPlots.every(plot => plot.status_pengamatan === 'Processed')
    );
  };

  // HAPUS FUNGSI gatherPlotsToUpdateInfo, handleOpenDialog, handleCloseDialog, handleConfirmAction

  return {
    showDraftMenu,
    showProcessedMenu,
    showApprovedMenu,
    showDownloadEntryMenu,
    allSelectedItemsAreOnlyProcessed,
    getSelectedOrders
  };
};